import { render, staticRenderFns } from "./texture.vue?vue&type=template&id=afdcd092&scoped=true"
import script from "./texture.vue?vue&type=script&lang=js"
export * from "./texture.vue?vue&type=script&lang=js"
import style0 from "./texture.vue?vue&type=style&index=0&id=afdcd092&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afdcd092",
  null
  
)

export default component.exports